import {Component, inject, OnInit} from '@angular/core';
import {IVehicle} from '@service-and-repairs/awpintegrationlib';
import {UserData} from '../../../core/user/models/user-data';
import {UserService} from '../../../core/user/services/user.service';
import {DsBoxModule, DsButtonModule, DsModalModule} from '@bmw-ds/components';
import {DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-vehicle-selection',
  templateUrl: './vehicle-selection-overlay.component.html',
  styleUrls: ['./vehicle-selection-overlay.component.scss'],
  imports: [DsModalModule, DsBoxModule, DsButtonModule, DatePipe, TranslateModule]
})
export class VehicleSelectionOverlayComponent implements OnInit {
  private readonly userService: UserService = inject(UserService);

  visible: boolean = false;
  vehicleList: IVehicle[];
  locale: string;

  private selectionCallback: (vehicle: IVehicle) => void;
  private cancelCallback: () => void;

  ngOnInit(): void {
    this.userService.user$.subscribe((user: UserData) => this.locale = user?.getLocale());
  }

  vehicleSelected(vehicle: IVehicle): void {
    this.visible = false;
    this.selectionCallback?.(vehicle);
  }

  show(vehicleList: IVehicle[]): Promise<IVehicle> {
    this.vehicleList = vehicleList;
    this.visible = true;
    return new Promise<IVehicle>((resolve, reject) => {
      this.selectionCallback = resolve;
      this.cancelCallback = reject;
    });
  }

  close(): void {
    this.visible = false;
    this.cancelCallback?.();
  }
}
